/* eslint-disable */
import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from '../common/Icon'
import Table from '../common/Table'
import Pagination from '../order/Pagination'
import axios from 'axios'
import zIndex from '../../utils/zIndexScale'

const LEFT = 'left'
const CENTER = 'center'

const TableWithBorder = styled(Table)`
  border-collapse: separate;
  border-color: #fdfdfd;
  border-spacing: 0 5px;
`

const TableWrap = styled.div`
  position: relative;
`

const Tbody = styled.tbody`
  tr {
    border: 1px solid #fff;
    box-shadow: 0px 1px 20px rgba(90, 102, 124, 0.08);
    border-radius: 3px;
    transition: all 0.2s ease-in;

    td {
      position: relative;
      background-color: #fff;
      word-break: break-all;
      cursor: pointer;
      font-size: 12px;
      color: #212833;
      text-align: left;
      line-height: 44px;
      border: none;
    }

    td:first-child {
      border-left: 1px solid #fff;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      text-indent: 10px;
    }

    td:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &:hover {
      box-shadow: 0px 1px 20px rgba(90, 102, 124, 0.2);
    }
  }
`

const Thead = styled.thead`
  background: #fdfdfd;
  background-size: auto 100%;
  tr {
    font-size: 13px;
    color: #48515d;
    border: none;
    box-shadow: none;
    &:hover {
      box-shadow: none;
    }
  }
  th {
    background-color: #fdfdfd;
    /* padding: 0 5px; */
    word-break: break-all;
    cursor: pointer;
    color: #848e9c;
    height: 44px;
    text-align: left;
    line-height: 44px;
  }
  th:first-child {
    text-indent: 10px;
  }
  .showSortMark {
    i {
      display: none;
    }
  }
  .sortHd {
    i {
      display: inline-block;
    }
  }
`

const IconWrap = styled.span`
  i {
    font-size: 12px;
    margin-left: 4px;
    transform: scale(0.6);
  }
`

const HeaderLeft = styled.div`
  display: flex;
  justify-content: flex-start;
`

const HeaderRight = styled.div`
  display: flex;
  justify-content: flex-end;
`

const HeaderCenter = styled.div`
  display: flex;
  justify-content: center;
`

const FixedTableHead = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  z-index: ${zIndex.fixedTableHeader};
  width: 1200px;
  transform: translate(-50%, 0);
`

const FixedTableBody = styled.div`
  position: relative;
`

const PageWrap = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`

const More = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  i {
    color: #848e9c;
  }
  &:hover i {
    color: #f0b90b;
  }
`

const DetailContentWrap = styled.div`
  position: relative;
  top: -15px;
  padding-top: 10px;
`

class OrderTable extends PureComponent {
  static propTypes = {
    dataSource: PropTypes.array,
    columns: PropTypes.array.isRequired,
    onRowClick: PropTypes.func,
    isFixedHeader: PropTypes.bool,
    sort: PropTypes.func,
    pageObj: PropTypes.object,
    total: PropTypes.number,
    primaryKey: PropTypes.string,
    expandedRowApi: PropTypes.string,
    expandedRowRender: PropTypes.func,
    expandedRowApiParam: PropTypes.func,
  }

  static defaultProps = {
    dataSource: [],
    current: 1,
    onRowClick: null,
    paging: null,
    isFixedHeader: false,
    sort: () => {},
    pageObj: {},
    total: 0,
    primaryKey: '',
    expandedRowApi: '',
    expandedRowRender: null,
    expandedRowApiParam: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      data: props.dataSource,
      columns: props.columns,
      sortType: 'sort_desc',
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.dataSource, columns: nextProps.columns })
  }

  onRowClick = rowData => {
    const { onRowClick } = this.props
    onRowClick && onRowClick(rowData)
  }

  _getColGroup() {
    const { isFixedHeader, columns } = this.props
    if (isFixedHeader) {
      const cols = columns.map((item, index) => <col style={{ width: item.width }} key={index} />)
      return cols
    }
    return <Fragement />
  }

  _renderTitle(title) {
    if (title.type === 'string') {
      return <span>{title}</span>
    }
    return title
  }

  _renderHeaderDetails(title, sortType) {
    return [
      this._renderTitle(title),
      <IconWrap>
        <Icon type={sortType} />
      </IconWrap>,
    ]
  }

  _renderHeader(headerAlign, title, sortType) {
    if (headerAlign === LEFT) {
      return <HeaderLeft>{this._renderHeaderDetails(title, sortType)}</HeaderLeft>
    }
    if (headerAlign === CENTER) {
      return <HeaderCenter>{this._renderHeaderDetails(title, sortType)}</HeaderCenter>
    }
    return <HeaderRight>{this._renderHeaderDetails(title, sortType)}</HeaderRight>
  }

  generateHead = () => {
    const { sortType, columns } = this.state
    const { expandedRowRender } = this.props
    const theads = columns.map((item, index) => {
      if (item.sorter) {
        const className = !item.isShowSortMark ? 'showSortMark' : 'sortHd'
        return (
          <th
            key={index}
            data-key={item.dataIndex}
            className={className}
            onClick={this.handleHeadClick}
            style={{ width: item.width }}
          >
            {this._renderHeader(item.headerAlign, item.title, sortType)}
          </th>
        )
      }
      return <th key={index}>{item.title}</th>
    })

    if (expandedRowRender) {
      theads.push(<th key={theads.length}></th>)
    }

    return <tr>{theads}</tr>
  }

  isDataShow = key => {
    const { columns } = this.state
    for (let i = 0, len = columns.length; i < len; i++) {
      if (columns[i].dataIndex === key) {
        return true
      }
    }
    return false
  }

  _findColth = key => {
    const { columns } = this.state
    for (let i = 0, len = columns.length; i < len; i++) {
      if (columns[i].dataIndex === key) {
        return columns[i]
      }
    }
    return null
  }

  _expandRow = async record => {
    const { data } = this.state
    const { primaryKey, expandedRowApi, expandedRowApiParam } = this.props
    let newData
    if (expandedRowApi) {
      const params = expandedRowApiParam && expandedRowApiParam(record)
      const detail = await request(expandedRowApi, params)
      newData = data.map(item => {
        const newItem = { ...item }
        if (record[primaryKey] === item[primaryKey]) {
          newItem.expand = !item.expand
          newItem.detail = detail
        } else {
          newItem.expand = false
        }
        return newItem
      })
    } else {
      newData = data.map(item => {
        if (record[primaryKey] === item[primaryKey]) {
          return { ...item, expand: !item['expand'] }
        } else {
          return { ...item, expand: false }
        }
      })
    }

    this.setState({ data: newData })
  }

  generateBody = () => {
    let { columns, data } = this.state
    const { expandedRowRender } = this.props

    const tbody = data.map((item, trIndex) => {
      const tdArr = []
      Object.keys(item).forEach(key => {
        if (this.isDataShow(key)) {
          tdArr.push(item[key])
        }
      })

      const tds = tdArr.map((value, index) => {
        const thCol = columns[index]
        if (thCol && thCol.render) {
          return (
            <td key={index} style={{ width: thCol.width }}>
              {thCol.render(item, trIndex)}
            </td>
          )
        }
        return (
          <td key={index} style={{ width: thCol.width }}>
            {value}
          </td>
        )
      })

      if (expandedRowRender) {
        tds.push(
          <td>
            <More
              onClick={() => {
                this._expandRow(item)
              }}
            >
              <Icon type="detail-D" />
            </More>
          </td>
        )
      }

      const trs = item.expand ? (
        <Fragment>
          <tr
            key={trIndex}
            onClick={() => {
              this.onRowClick(item)
            }}
          >
            {tds}
          </tr>
          <tr style={{ position: 'relative' }}>
            <td colSpan={columns.length + 1}>
              <DetailContentWrap>
                {expandedRowRender && expandedRowRender(item.detail)}
              </DetailContentWrap>
            </td>
          </tr>
        </Fragment>
      ) : (
        <tr
          key={trIndex}
          onClick={() => {
            this.onRowClick(item)
          }}
        >
          {tds}
        </tr>
      )

      return trs
    })

    return tbody || []
  }

  handleHeadClick = event => {
    const { currentTarget } = event
    const { sortType } = this.state

    const dataIndex = currentTarget.getAttribute('data-key')

    this.props.sort && this.props.sort(dataIndex, sortType)

    this.setState({ sortType: sortType === 'sort_asc' ? 'sort_desc' : 'sort_asc' })
  }

  generateFixedTable = () => {
    const colGroup = this._getColGroup()
    const thead = this.generateHead()
    const tbody = this.generateBody()
    return (
      <div>
        <FixedTableHead>
          <TableWithBorder>
            <colgroup>{colGroup}</colgroup>
            <Thead>{thead}</Thead>
          </TableWithBorder>
        </FixedTableHead>
        <FixedTableBody>
          <TableWithBorder>
            <colgroup>{colGroup}</colgroup>
            <Tbody>{tbody}</Tbody>
          </TableWithBorder>
        </FixedTableBody>
      </div>
    )
  }

  generateTable = () => {
    const thead = this.generateHead()
    const tbody = this.generateBody()
    return (
      <TableWithBorder>
        <Thead>{thead}</Thead>
        <Tbody>{tbody}</Tbody>
      </TableWithBorder>
    )
  }

  render() {
    const { isFixedHeader, paging, total, dataSource } = this.props
    const content = isFixedHeader ? this.generateFixedTable() : this.generateTable()
    return (
      <div>
        <TableWrap>{content}</TableWrap>
        {paging && dataSource.length > 0 && (
          <PageWrap>
            <Pagination totalCount={total} paging={paging} />
          </PageWrap>
        )}
      </div>
    )
  }
}

const request = async (api, params) => {
  try {
    const response = await axios.get(api, { params })
    return response.data
  } catch (err) {
    return {}
  }
}

export default OrderTable
